import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import useUser from "../../hooks/useUser";
//import { CgDanger } from "react-icons/cg";
import { Container } from "react-bootstrap";
import ErrorTooltip from "../Home/MyForm/DataClient/ErrorTooltip";
//import { debugModule } from "../../../../../api/apiDebug";
//import { myId } from "../../../../../lib/MyLibrary";

const MESES = [
  "Ene",
  "Feb",
  "Mar",
  "Abr",
  "May",
  "Jun",
  "Jul",
  "Ago",
  "Sep",
  "Oct",
  "Nov",
  "Dic",
];
const BOTTOMYEAR = 1940;
let YEARS = [];
let today = new Date();
let actualYear = today.getFullYear();

for (let i = actualYear - 10; i > BOTTOMYEAR; i--) YEARS.push(i);

let DAYS = [];

for (let i = 0; i < 31; i++) DAYS.push(i + 1);

const myRegExp = /^[a-záéíóúÁÉÍÓÚñÑ ,.'-]+$/i;

const expresionEmail = /^\w+([.-_+]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/;

//  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const PersonalExpress = () => {
  const [dataUser, setDataUser] = useUser();
  const {
    email,
    nameUser,
    paterno,
  } = dataUser;




  const [isValidNameUser, setIsValidNameUser] = useState(false);
  const [isValidPaterno, setIsValidPaterno] = useState(false);
  //const [isValidMaterno, setIsValidMaterno] = useState(false);
  const [isValidEmail, setIsValidEmail] = useState(false);

const validateEmail = ()=>{
  if(expresionEmail.test(String(email).toLowerCase())) 
  setIsValidEmail(true);
else 
  setIsValidEmail(false);
}
  

  
  

  useEffect(() => {
    if (dataUser.nameUser) validateNameUSer();
    if (dataUser.paterno) validatePaterno();
    //if (dataUser.materno) validateMaterno();
    if (dataUser.email) validateEmail();

  }, [
    dataUser.nameUser,
    dataUser.paterno,
    dataUser.email
  ]);

  useEffect(() => {
    setDataUser({
      ...dataUser,
      isValidNameUser,
      isValidPaterno,
      isValidEmail
    });
  }, [
    isValidNameUser,
    isValidPaterno,
    isValidEmail
  ]);

  

  const validateNameUSer = () => {
    const result = myRegExp.test(dataUser.nameUser.trim());

    if (
      dataUser.nameUser.trim().length > 1 &&
      dataUser.nameUser.trim().length < 21 &&
      result
    ) {
      setIsValidNameUser(true);
    } else {
      setIsValidNameUser(false);
    }
    //console.log('Result:..',result);
    return;
  };
  const validatePaterno = () => {
    const result = myRegExp.test(dataUser.paterno.trim());

    if (
      dataUser.paterno.trim().length > 1 &&
      dataUser.paterno.trim().length < 41 &&
      result
    )
      setIsValidPaterno(true);
    else setIsValidPaterno(false);

    //console.log('Result:..',result);
    return;
  };
  /* const validateMaterno = () => {
    const result = myRegExp.test(dataUser.materno.trim());

    if (
      dataUser.materno.trim().length > 1 &&
      dataUser.materno.trim().length < 41 &&
      result
    )
      setIsValidMaterno(true);
    else setIsValidMaterno(false);

    //console.log('Result:..',result);
    return;
  }; */
 
  const handleChange = (e) => {
    setDataUser({
      ...dataUser,
      [e.target.name]: e.target.value,
    });
    //console.log(`${e.target.name}: ${e.target.value}`)
    //if (dataUser.nameUser) validateNameUSer();
    //if (dataUser.paterno) validatePaterno();
  };

  /* const sendDataDebug = async(data)=>{
    try {
      const result = await debugModule(data);
      console.log('resultDebug(front-back):..',result);
    } catch (error) {
      console.log(error);
    }
  } */

  return (
    <div className="ps-1 w-100">
      <Form>
        {/* <Form.Group className="mb-3" controlId="formGridNames">
          <Form.Label>Nombre(s)</Form.Label>
          <Container fluid className="d-flex">
            <Form.Control
              value={nameUser ? nameUser : ""}
              name="nameUser"
              onChange={handleChange}
              placeholder="Nombre(s)"
            />
            {!isValidNameUser && <ErrorTooltip msg={"Capturar 2-20 letras"} />}
          </Container>
        </Form.Group> */}
        <Row className="mb-3">
          <Form.Group className="col-12 col-md-6" controlId="formGridPaterno">
            <Form.Label>Nombre:</Form.Label>
            <Container className="d-flex">
              <Form.Control
                value={nameUser ? nameUser : ""}
                name="nameUser"
                onChange={handleChange}
                placeholder="Nombre"
              />
              {!isValidNameUser && <ErrorTooltip msg={"Capturar 2-40 letras"} />}
            </Container>
          </Form.Group>

          <Form.Group className="col-12 col-md-6" controlId="formGridMaterno">
            <Form.Label>Apellido:</Form.Label>
            <Container className="d-flex">
              <Form.Control
                value={paterno ? paterno : ""}
                name="paterno"
                onChange={handleChange}
                placeholder="Apellido"
              />
              {!isValidPaterno && <ErrorTooltip msg={"Capturar 2-40 letras"} />}
            </Container>
          </Form.Group>
        </Row>

        <Form.Group className="mb-3" controlId="formGridEmail">
          <Form.Label>Email</Form.Label>
          <Container className="d-flex">
          <Form.Control
            value={email!=='default' ? email : ""}
            name="email"
            onChange={handleChange}
            type="email"
            placeholder="Email"
          />
          {!isValidEmail && <ErrorTooltip msg={"Capturar un E-mail Válido"} />}
          </Container>
        </Form.Group>        
      </Form>
    </div>
  );
}

export default PersonalExpress